module.exports = __webpack_public_path__ + "media/images/menu/rocks_left-a2d01ba58a03c20ba6135bf50d638012.png";